import { FunctionComponent, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { ReactComponent as Error } from "@src/modules/shared/components/TestsStatus/icons/error.svg";
import { ReactComponent as Help } from "@src/modules/shared/components/TestsStatus/icons/help.svg";
import { ReactComponent as Hourglass } from "@src/modules/shared/components/TestsStatus/icons/hourglass.svg";
import { ReactComponent as Ok } from "@src/modules/shared/components/TestsStatus/icons/ok.svg";
import {
  StatusDescription,
  StatusWrapper,
} from "@src/modules/shared/components/TestsStatus/TestsStatus.components";
import { TestStatus } from "@src/modules/shared/types";

interface Props {
  status: TestStatus;
  hasDescription?: boolean;
  customLabel?: string;
}

const TestsStatus: FunctionComponent<Props> = ({
  status,
  hasDescription = true,
  customLabel,
}) => {
  const { t } = useTranslation();
  const statusIcon = useMemo(() => {
    return status === TestStatus.Ready ? (
      <Ok />
    ) : status === TestStatus.InProgress ? (
      <Hourglass />
    ) : status === TestStatus.ActionNeeded ? (
      <Help />
    ) : (
      <Error />
    );
  }, [status]);

  const statusText = useMemo(
    () =>
      status === TestStatus.Ready
        ? t("Ready to go")
        : status === TestStatus.InProgress
        ? t("In progress")
        : status === TestStatus.ActionNeeded
        ? t("Needs Attention")
        : t("Test failed"),
    [status, t],
  );

  return (
    <StatusWrapper status={status}>
      {statusIcon}
      {hasDescription && (
        <StatusDescription status={status}>
          {customLabel ?? statusText}
        </StatusDescription>
      )}
    </StatusWrapper>
  );
};

export default TestsStatus;
